// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        padding: 0 16px 0 45px;
        display: flex;
        justify-content: space-around;
        ${({ isPrimaryNavigation }: any) => !isPrimaryNavigation && `justify-content: center;`}
        ${({ isPrimaryNavigation }: any) =>
            isPrimaryNavigation &&
            css`
                & > div {
                    flex: 1;
                }
            `}
    `,
};

mainNavigationStyles.menuItemTypography = {
    ...({ as: "div" } as any),
    variant: "headerSecondary",
    // color: "secondary.contrast",
    css: css`
        &&& {
            color: ${getColor("text.main")};
        }
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        text-transform: initial;
        .firstWord {
            font-size: 18px;
            font-weight: bold;
            line-height: 18px;
            color: ${getColor("common.ui2")};
            text-transform: uppercase;
        }
        .restWords {
            font-size: 12px;
            color: ${getColor("text.main")};
            text-transform: uppercase;
        }
    `,
};

mainNavigationStyles.menuItemIcon = {
    css: css`
        &&& {
            color: ${getColor("common.ui9")};
        }
        margin-left: 5px;
        ${({ isPrimaryNavigation }: any) =>
            isPrimaryNavigation &&
            `
            margin-left: 0;
            position: absolute;
            bottom: 7px;
            left: 50%;
            transform: translateX(-50%);
            `}
    `,
    size: 9,
    color: "common.ui9",
};

mainNavigationStyles.menuItem = {
    css: css`
        flex: 1;
        display: flex;
        align-items: center;
        height: 70px;
        padding: 0 20px;
        ${({ isPrimaryNavigation }: any) => !isPrimaryNavigation && `height: 50px;`}

        background-size: 100% 200%;
        background-image: linear-gradient(to bottom, transparent 50%, ${getColor("common.ui4")} 50%);

        transition: all 200ms ease-in-out;
        &.active,
        &:hover {
            background-position: 0 100%;
            &&& * {
                color: white;
            }
        }
    `,
};

mainNavigationStyles.cascadingMenu = {
    cssOverrides: {
        wrapper: css`
            flex: 1;
        `,
    },
};
